import React, { Fragment } from "react";
import InputCard from "../../common/InputCard";
import SingleRow from "../../common/SingleRow";

class CardsLayout extends React.Component {
  state = {};
  constructor() {
    super();
    this.cardsLayout = [
      // cards
      {
        title: "card1",
        hideTitle: true,
        items: [
          {
            label: {
              value: "In-And-Out Item Flag",
              size: "85%"
            },
            item: {
              node: "input",
              type: "string",
              filter: "[^NnYy]" /* only allow N n->N y->Y */,
              value: "",
              intemName: "inOutFlag",
              forceCaps: true,
              maxLength: 1
            },
            size: "40%"
          },
          {
            label: {
              value: "Order Type",
              size: "80%"
            },
            item: {
              node: "input",
              type: "string",
              onBlur: "checkOrderType",
              value: "",
              filter: "[^VvBbTtRrAaDdFfIiNnZzEePpHhYyXx]",
              intemName: "orderType",
              maxLength: 2,
              forceCaps: true
            },
            size: "30%"
          },
          {
            label: {
              value: "EOQ Cost",
              size: "65%"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              filter: "[^0-9][.]",
              maxNumber: "999.99",
              intemName: "fixedOrderCost"
              // decimals: 2
            },
            size: "30%"
          },
          {
            label: {
              value: "Warehouse EOQ Logic",
              size: "85%"
            },
            item: {
              node: "input",
              type: "string",
              filter: "[^Nn ]" /* only allow N n->N or ' ' */,
              value: "",
              forceCaps: true,
              maxLength: 1,
              intemName: "whseEoqFlag" /////////////////////////////////////////////////////
            },
            size: "40%"
          },
          {
            label: {
              value: "Reserve Inventory",
              size: "50%"
            },
            item: {
              node: "input",
              type: "number",
              value: "",
              intemName: "reserveInventory"
            },
            size: "60%"
          },
          {
            label: {
              value: "Direct Replenishment Flag",
              size: "85%"
            },
            item: {
              node: "input",
              type: "string",
              onBlur: "checkDirectReplenFlag",
              filter: "[^Nn ]" /* only allow N n->N or ' ' */,
              value: "",
              intemName: "directReplenFlag",
              forceCaps: true,
              maxLength: 1
            },
            size: "40%"
          },
          {
            label: {
              value: "Store Order Minimum",
              size: "50%"
            },
            item: {
              node: "input",
              type: "number",
              value: "",
              intemName: "storeOrderMin"
            },
            size: "60%"
          },
          {
            label: {
              value: "Inventory Action Code",
              size: "85%"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              filter: "[^DdFfIiOoPpRrSsTtVv ]",
              maxLength: 1,
              forceCaps: true,
              intemName: "invActionCode"
            },
            size: "40%"
          },
          {
            label: {
              value: "Store Order Maximum",
              size: "50%"
            },
            item: {
              node: "input",
              type: "number",
              value: "",
              intemName: "storeOrderMax"
            },
            size: "60%"
          }
        ]
      },
      {
        title: "card2",
        hideTitle: true,
        items: [
          {
            label: {
              value: ""
            },
            span: {
              value: "...",
              alignment: "center",
              size: "100%"
            },
            item: {
              node: "onlySpan",
              value: "",
              intemName: "na"
            },
            size: "100%"
          }
        ]
      },
      {
        title: "card3",
        hideTitle: true,
        items: [
          {
            label: {
              value: "Slot",
              size: "72px"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "lineSlot" //////////////////////////////////////////////////////**** */
            },
            size: "calc(100% / 3)",
            readOnly: true
          },
          {
            label: {
              value: "Reserve On Order",
              size: "60%",
              fontSize: "88%"
            },
            item: {
              node: "input",
              type: "number",
              value: "",
              intemName: "onOrderReserve"
            },
            size: "calc(100% / 3)",
            readOnly: true
          },
          {
            label: {
              value: "Recall Expected",
              size: "57%",
              fontSize: "94%"
            },
            item: {
              node: "input",
              type: "number",
              value: "",
              intemName: "recallQtyExpect"
            },
            size: "calc(100% / 3)",
            readOnly: true
          },
          {
            label: {
              value: "In Stock",
              size: "72px"
            },
            item: {
              node: "input",
              type: "number",
              value: "",
              intemName: "inStock"
            },
            size: "calc(100% / 3)",
            readOnly: true
          },
          {
            label: {
              value: "VDP Invoice Bal*",
              size: "60%",
              fontSize: "94%"
            },
            item: {
              node: "input",
              type: "number",
              value: "",
              intemName: "vendInvBal"
            },
            size: "calc(100% / 3)",
            readOnly: true
          },
          {
            label: {
              value: "Setup Date",
              size: "57%"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "setupDate"
            },
            size: "calc(100% / 3)",
            readOnly: true
          },
          {
            label: {
              value: "On Order",
              size: "72px",
              fontSize: "85%"
            },
            item: {
              node: "input",
              type: "number",
              value: "",
              intemName: "onOrderRegular"
            },
            size: "calc(100% / 3)",
            readOnly: true
          },
          {
            label: {
              value: ""
            },
            span: {
              value: "",
              alignment: "center",
              size: "100%"
            },
            item: {
              node: "onlySpan",
              value: "",
              intemName: "whseIntl"
            },
            size: "calc(100% / 3)"
          },
          {
            label: {
              value: "Change Date",
              size: "57%"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "changeDate"
            },
            size: "calc(100% / 3)",
            readOnly: true
          }
        ]
      },

      {
        title: "Suggested Inventory",
        items: [
          {
            label: {
              value: "A",
              size: "50%"
            },
            item: {
              node: "input",
              type: "number",
              value: "",
              intemName: "retailLevelA"
            },
            size: "20%"
          },
          {
            label: {
              value: "B",
              size: "50%"
            },
            item: {
              node: "input",
              type: "number",
              value: "",
              intemName: "retailLevelB"
            },
            size: "20%"
          },
          {
            label: {
              value: "C",
              size: "50%"
            },
            item: {
              node: "input",
              type: "number",
              value: "",
              intemName: "retailLevelC"
            },
            size: "20%"
          },
          {
            label: {
              value: "D",
              size: "50%"
            },
            item: {
              node: "input",
              type: "number",
              value: "",
              intemName: "retailLevelD"
            },
            size: "20%"
          },
          {
            label: {
              value: "E",
              size: "50%"
            },
            item: {
              node: "input",
              type: "number",
              value: "",
              intemName: "retailLevelE"
            },
            size: "20%"
          }
        ]
      }
    ];
  }

  componentDidMount() {
    this.setState({ layout: this.cardsLayout });
  }

  formatData = props => {
    if (props) {
      this.cardsLayout.map((card, c) => {
        const inputName = Object.keys(props[c])[0];
        card.items.map((item, i) => {
          if (
            props[c][inputName][i] &&
            item.item.intemName === props[c][inputName][i].name
          ) {
            item.item.value =
              props[c][inputName][i].value === undefined ||
              props[c][inputName][i].value === "" ||
              props[c][inputName][i].value === false
                ? ""
                : props[c][inputName][i].value;
            item.item.obj = props[c][inputName][i].obj;
            if (item.span) {
              item.span.value = props[c][inputName][i].span;
            }
            item.label.value = props[c][inputName][i].label;
            item.item.injectedValue = props[c][inputName][i].injectedValue;
          }
          return null;
        });
        return null;
      });
    }
    return null;
  };
  getCardsInfo = (info, title) => {
    this.props.setCardsInfo({ [title]: info });
  };
  renderCards = () => {
    this.formatData(this.props.cardsData);
    const card = this.cardsLayout;
    return (
      <Fragment>
        <div style={{ flex: 1 }}>
          <InputCard
            jsonObj={card[0]}
            setCardsInfo={this.getCardsInfo}
            functions={{
              checkOrderType: this.props.checkOrderType,
              checkDirectReplenFlag: this.props.checkDirectReplenFlag,
              checkFixedOrderCost: this.props.checkFixedOrderCost
            }}
          />
          <InputCard jsonObj={card[3]} setCardsInfo={this.getCardsInfo} />
        </div>
        <div style={{ flex: 1 }}>
          <InputCard jsonObj={card[1]} setCardsInfo={this.getCardsInfo} />
          <InputCard jsonObj={card[2]} setCardsInfo={this.getCardsInfo} />
        </div>
      </Fragment>
    );
  };

  render() {
    return (
      <Fragment>
        <div
          className="cards-container"
          style={{ display: "flex", alignItems: "flex-start" }}
        >
          {this.renderCards()}
        </div>
      </Fragment>
    );
  }
}
export default CardsLayout;
